import { useState, useEffect } from "react";

export default function PdfPreview({ src }: { src: string }) {
  const [iframeUrl, setIframeUrl] = useState(src);

  useEffect(() => {
    // Create a media query to check for screens wider than 1536px (2xl breakpoint)
    const mediaQuery = window.matchMedia("(min-width: 1536px)");

    // Function to handle changes in the media query
    // This helps adjust the zoom level of the pdf when transferring between laptop and monitor screens
    const handleMediaQueryChange = (e: MediaQueryList | MediaQueryListEvent) => {
      if (e.matches) {
        setIframeUrl(`${src}#zoom=125`);
      } else {
        setIframeUrl(`${src}#zoom=100`);
      }
    };

    // Set initial state based on current screen size
    handleMediaQueryChange(mediaQuery);

    // Listen for changes
    mediaQuery.addEventListener("change", handleMediaQueryChange);

    // Cleanup function to remove the event listener when component unmounts
    return () =>
      mediaQuery.removeEventListener("change", handleMediaQueryChange);
  }, [src]);

  return (
    <div className="flex h-full w-full items-center justify-center">
      <iframe
        src={iframeUrl}
        className="h-[75vh] w-[60vw] 2xl:h-[70vh] 2xl:w-[50vw]"
      />
    </div>
  );
}
